module.exports = {"create":"Tạo Cộng đồng","createDescription":"Tạo cộng đồng mới cho Người quản lý Đối tác","success":"Cộng đồng được tạo thành công!"};